import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import resources from "./locales";

export const allowedLng = [
  "ar",
  "en",
  "fr",
  "co",
  "de",
  "es",
  "it",
  "ja",
  "pt",
  "nl",
  "ru",
  "uk",
];

export const navigatorLanguage =
  navigator.languages[0]?.split("-")[0] ??
  navigator.language.split("-")[0] ??
  "en";

i18n.use(initReactI18next).init({
  fallbackLng: navigatorLanguage,
  debug: false,
  interpolation: {
    escapeValue: false,
  },
  react: {
    nsMode: "default",
  },
  resources,
});

export default i18n;
